<template lang="html">
  <div id="resultados">
    <div class="vx-col lg:w-1/2 sm:w-full">
      <label for="destinos">Destino</label>
      <select name="cars" id="destinos" v-model="caso.destino" class="v-select vs--single vs--searchable vs-input--input">
        <option :value='tipo.Id' v-for="tipo in destinos"  :key="">{{tipo.Nombre}}</option>
      </select>
    </div>
    <Adquisicion v-on:updateValores="update($event)" v-if="caso.destino==1"/>
    <Terreno v-on:updateValores="update($event)" v-if="caso.destino==5"/>
    <Mejora v-on:updateValores="update($event)" v-if="caso.destino==19"/>
    <Liquidez v-on:updateValores="update($event)" v-if="caso.destino==3"/>
    <br>
    <div class="items-list-view" v-if="items.length != 0">
      <div v-for="item in items"  :key="item.Id">
        <Resultados :item="item" class="mb-base" @next="$emit('nextTab')"></Resultados>

      </div>
    </div>
    <div class="vx-row" v-else>
        <div class="vx-col w-full md:w-3/3 sm:w-2/2 mb-base">
          <vx-card class="text-center cursor-pointer">
            <img src="@/assets/images/pages/graphic-6.png" alt="graphic" width="180" class="mx-auto mb-4">
            <h4 class="mb-2">No encontramos resultados</h4>
            <small>Intenta con un plazo o monto de crédito distinto</small>
          </vx-card>
        </div>
      </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState, mapMutations } from 'vuex';
import Adquisicion from '@/views/Destinos/Adquisicion.vue'
import Liquidez from '@/views/Destinos/Liquidez.vue'
import Mejora from '@/views/Destinos/Mejora.vue'
import Terreno from '@/views/Destinos/Terreno.vue'
import Resultados from '@/views/Resultados.vue'
export default {
  props: {
    destino: {
      type: Number,
      required: false
    }
  },
  components: {
    Adquisicion,
    Resultados,
    Liquidez,
    Mejora,
    Terreno
  },
  data(){
		return{
      caso:{
        valor:'',
        credito:'',
        destino:1,
        plazos:[],
        esquemas:[],
        mensualidad:'',
        plazoRestante:'',
      },
      items:[],
      sendEmail:true,
      ejecutivo:'',
      casoCompleto:{},
      destinos:[
        {'Id':1, 'Nombre':'Adquisición de vivienda'},
        {'Id':3, 'Nombre':'Liquidez'},
        {'Id':5, 'Nombre':'Adquisición de Terreno'},
        {'Id':19, 'Nombre':'Mejora de hipoteca'},
      ],
    }
  },
  mounted(){
    this.dameEjecutivo()
  },
  computed:{
    ...mapState(['casoId','key','solicitante','phone']),
  },
  methods:{
    ...mapMutations(['saveCasoId']),
    sendEmailToBroker(id){
      this.sendEmail=false
      var objRequest= {
        to:this.ejecutivo,
        email: this.casoCompleto.Solicitante,
        name: this.casoCompleto.SolicitanteNombre,
        phone: this.phone,
        id: id,
      }

      axios.post('https://pcotizador.socasesores.com:444/emailComparaleProd/widget.php',objRequest,{headers : {'Content-Type':'application/json; charset=UTF-8'}})
      .then().catch(function (error) {
        console.log(error);
      })
    },
    dameCaso(id){
      let self=this
      var objRequestDameCaso = {
        strApiKey: this.key,
        strMetodo: 'DameCaso',
        objCaso: {
         Id: id
        }
      }
      this.$axios.post('/',objRequestDameCaso,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
      .then(
        response => {
          if(response.data.intEstatus == 0){
            this.casoCompleto=response.data.objContenido
            this.sendEmailToBroker(id)

          }else {
            this.$vs.notify({
              title:'Ocurrio un error en DameCaso',
              text:response.data.strError,
              color:'danger',
              position:'top-right'
            })
          }
        }
      ).catch(function (error) {
        self.$vs.notify({
          title:'Ocurrio un error de sistema',
          text:error,
          color:'danger',
          position:'top-right'
        })
      })
    },
    update(e){
      this.caso.plazos=[]
      this.caso.esquemas=[]
      for (var i = 0; i < e.plazosACotizar.length; i++) {
        if(typeof e.plazosACotizar[i] == 'object'){
          this.caso.plazos.push(e.plazosACotizar[i].value)
        }else {
          this.caso.plazos.push(e.plazosACotizar[i].substring(0, 2))
        }
      }
      for (var i = 0; i < e.esquemasACotizar.length; i++) {
        this.caso.esquemas.push(parseInt(e.esquemasACotizar[i].value))
      }
      this.caso.valor=e.valor
      this.caso.credito=e.credito
      this.caso.mensualidad=e.mensualidad
      this.caso.plazoRestante=e.plazoRestante
      this.registrarCaso()
    },
    registrarCaso(){
      this.$vs.loading({
        container: '#resultados',
        scale: 0.6
      })
      var objRequestRegistraCaso1 = {}
      if (typeof this.caso.valor == 'string') {
        this.caso.valor=this.caso.valor.replace(/,/g,"")
      }
      if (typeof this.caso.credito == 'string') {
        this.caso.credito=this.caso.credito.replace(/,/g,"")
      }
      if (this.casoId) {
        if(this.caso.destino == '19'){
          objRequestRegistraCaso1 = {
            strApiKey: this.key,
            strMetodo: 'RegistraCaso',
            objCaso: {
              Id:this.casoId,
              ValorInmueble : parseFloat(this.caso.valor),
              SaldoInsoluto : parseFloat(this.caso.credito),
              Plazos : this.caso.plazos,
              Solicitante: this.solicitante,
              Destino : this.caso.destino,
              Esquemas:this.caso.esquemas,
              PlazoRestante:this.caso.plazoRestante,
              PagoMensualActual: parseFloat(this.caso.mensualidad.replace(/,/g,"")),
              VersionOrigen:'Widget',
              StatusCaso:'Nuevo'
            }
          }
        }else {
          objRequestRegistraCaso1 = {
            strApiKey: this.key,
            strMetodo: 'RegistraCaso',
            objCaso: {
              Id:this.casoId,
              ValorInmueble : parseFloat(this.caso.valor),
              MontoSolicitado : parseFloat(this.caso.credito),
              Plazos : this.caso.plazos,
              Solicitante: this.solicitante,
              Destino : this.caso.destino,
              Esquemas:this.caso.esquemas,
              VersionOrigen:'Widget',
              StatusCaso:'Nuevo'
            }
          }
        }
      }else {
        if(this.caso.destino == '19'){
          objRequestRegistraCaso1 = {
            strApiKey: this.key,
            strMetodo: 'RegistraCaso',
            objCaso: {
              ValorInmueble : parseFloat(this.caso.valor),
              SaldoInsoluto : parseFloat(this.caso.credito),
              Plazos : this.caso.plazos,
              Solicitante: this.solicitante,
              Destino : this.caso.destino,
              Esquemas:this.caso.esquemas,
              PlazoRestante:this.caso.plazoRestante,
              PagoMensualActual: parseFloat(this.caso.mensualidad.replace(/,/g,"")),
              VersionOrigen:'Widget',
              StatusCaso:'Nuevo'
            }
          }
        }else {
          objRequestRegistraCaso1 = {
            strApiKey: this.key,
            strMetodo: 'RegistraCaso',
            objCaso: {
              ValorInmueble : parseFloat(this.caso.valor),
              MontoSolicitado : parseFloat(this.caso.credito),
              Plazos : this.caso.plazos,
              Solicitante: this.solicitante,
              Destino : this.caso.destino,
              Esquemas:this.caso.esquemas,
              VersionOrigen:'Widget',
               StatusCaso:'Nuevo'
            }
          }
        }
      }
      this.$axios.post('/',objRequestRegistraCaso1,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
      .then(
        response => {
          if(response.data.intEstatus == 0){
            this.saveCasoId(response.data.objContenido.Id)
            this.dameCaso(response.data.objContenido.Id)

            this.cotiza(response.data.objContenido.Id)
          }else {
            this.$vs.notify({
              title:'Ocurrio un error en RegistraCaso',
              text:response.data.strError,
              color:'danger',
              position:'top-right'
            })
          }
        }

      ).catch(function (error) {
        this.$vs.notify({
          title:'Ocurrio un error de sistema',
          text:error,
          color:'danger',
          position:'top-right'
        })
      })
    },
    cotiza(id){
      let objRequestCotizaCaso = {
        strApiKey: this.key,
        strMetodo: 'Cotiza',
        objCaso: {
         Id: id
        }
      }
      this.$axios.post('/',objRequestCotizaCaso,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
      .then(
        response => {
          if(response.data.intEstatus == 0){
            this.items= response.data.objContenido
            this.items.sort((a,b) => (a.MensualidadPromedio > b.MensualidadPromedio) ? 1 : ((b.MensualidadPromedio > a.MensualidadPromedio) ? -1 : 0));
            this.$vs.loading.close('#resultados > .con-vs-loading')
          }else {
            this.$vs.notify({
              title:'Ocurrio un error en Cotiza',
              text:response.data.strError,
              color:'danger',
              position:'top-right'
            })
          }
        }
      ).catch(function (error) {
        console.log('Error al Cotizar',error);
      })
    },
    dameEjecutivo(){
      var objRequestListaCandidatosAutomaticos = {
        strApiKey: this.key,
        strMetodo: 'MisDatos',
      }

      this.$axios.post('/',objRequestListaCandidatosAutomaticos,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
      .then(
        response => {
          if(response.data.intEstatus == 0){
            this.ejecutivo= response.data.objContenido.EMail
          }
        }
      ).catch(function (error) {
        console.log(error);
      })
    }
  }
}
</script>

<style lang="css">
</style>
